import ListItem from '../../shared/styledComponents/ListItem';
import { InjectedStyledComponent } from '../../shared/InjectedStyledComponent';

export default InjectedStyledComponent(ListItem, 'selectionField', ['listItem']);